import * as React from "react"
import CustomizeBar from '../../header/CustomizeBar';
import { Outlet } from 'react-router-dom';

const CustomizingPage = () => {
	return (
		<div className=" w-full pl-1">
			<CustomizeBar />
			<Outlet />
		</div>
	);
};

export default CustomizingPage;
